var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStraightLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 20,
    viewBox: "0 0 120 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H120",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H120",
    stroke: "url(#paint1_linear)",
    strokeOpacity: 0.1,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H120",
    stroke: "url(#paint2_linear)",
    strokeOpacity: 0.15,
    strokeWidth: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.18921,
    y1: 7.52157,
    x2: 123.749,
    y2: 10.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -2.18921,
    y1: 7.52157,
    x2: 123.749,
    y2: 10.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -2.18921,
    y1: 7.52157,
    x2: 123.749,
    y2: 10.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003340"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightLine);
export default __webpack_public_path__ + "static/media/straight-line.b6d2e846139cabbd9302617b2f2b314e.svg";
export { ForwardRef as ReactComponent };